<template>
    <v-dialog v-model="dialog" max-width="700" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ $t('common.change_exercise') }}
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12" md="6">
                        <kimsa-combobox :label="$t('common.category')" :placeholder="$t('exercises.pick_one_category')" outlined dense
                            :items="categoriesOptions" @change="category = $event" :value="category" placeholder-class
                            ref="category" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <kimsa-combobox :label="$t('exercises.types')" :placeholder="$t('exercises.pick_type')" outlined
                            dense :items="typesOptions" @change="types = $event" placeholder-class multiple-with-chips
                            :readonly="!category" :value="types" ref="types" />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-combobox can-write :label="$tc('exercises.exercises', 1)"
                            :placeholder="$t('exercises.pick_exercise')" outlined dense :items="exercisesOptions"
                            @change="newExercise = $event" :value="newExercise" item-value="objectID" placeholder-class ref="exercise"
                            show-video :no-create-exercise="true" @showVideo="onShowVideo" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-btn block depressed x-large color="primary" class="normal-btn no-radius black--text"
                    :disabled="disabled" @click="changeExercise" :loading="loading">
                    {{ $t('common.change') }}
                </v-btn>
            </v-card-actions>

            <watch-video-dialog @hide="onHideVideo" :thumb="currentImg" :video="currentVideo" is-second-dialog
                ref="watchVideo" />
        </v-card>
    </v-dialog>
</template>

<script>
import { db } from '@/utils/Firebase'
import { Client, ExerciseIndex } from "@/utils/Algolia";
import { mapMutations, mapState, mapActions } from "vuex";
import KimsaCombobox from './inputs/KimsaCombobox.vue';
import WatchVideoDialog from './routines/WatchVideoDialog.vue';

export default {
    components: { KimsaCombobox, WatchVideoDialog },
    name: "ChangeExerciseDialog",
    props: {
        exercise: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            category: null,
            types: [],
            exercisesOptions: [],
            newExercise: null,
            currentImg: null,
            currentVideo: null,
        }
    },
    computed: {
        ...mapState(['dialogActive', 'categoriesOptions']),
        coachId(vm = this) {
            return vm.account?.studentSubscription?.coachId || null
        },
        typesOptions(vm = this) {
            if (!vm.category) return []
            return vm.category.types.map(type => ({ name: type, value: type }))
        },
        disabled(vm = this) {
            return !vm.newExercise
        }
    },
    async mounted() {
        const vm = this;
        if (vm.categoriesOptions.length === 0) await vm.fetchExerciseCategories()
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        ...mapActions(['fetchExerciseCategories']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
            vm.setDefaults()
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
        },
        reset() {
            const vm = this
            vm.category = null
            vm.types = []
            vm.newExercise = null
        },
        setDefaults() {
            const vm = this;
            vm.category = vm.categoriesOptions.find(category => category.name === vm.exercise.categories[0])
            vm.$nextTick(() => {
                vm.types = vm.exercise.types.map(type => ({ name: type, value: type }))
            })
        },
        async loadExercises() {
            const vm = this;
            if (vm.types.length === 0) return
            vm.exercisesOptions = []
            let filter = `(coachId:"${vm.coachId}" OR owner:"app") AND hide!=1 AND (types:"${vm.types.map(type => type.name).join('" OR types:"')}")`
            Client.clearCache()
            let { hits } = await ExerciseIndex.search('', { filters: filter, hitsPerPage: 100 });
            vm.exercisesOptions = hits;
        },
        async onShowVideo(item) {
            const vm = this
            vm.currentImg = item.img || item.video?.thumb || null
            vm.currentVideo = item.video?.url || null
            if (vm.$refs.exercise) vm.$refs.exercise.closeMenu()
            await vm.$refs.watchVideo.show()
        },
        onHideVideo() {
            if (this.$refs.exercise) this.$refs.exercise.openMenu()
        },
        changeExercise() {
            const vm = this;
            vm.$emit('success', {oldExercise: vm.exercise, newExercise: vm.newExercise})
            vm.hide()
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
        category() {
            this.types = []
        },
        types() {
            const vm = this
            vm.loadExercises()
        },
        exercise(val) {
            if (val && this.dialog) this.setDefaults()
        }
    }
}
</script>

<style scoped>
.card-container {
    border-radius: 0px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}
</style>